import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";

export const SUBSCRIPTION_OFFERS = gql(`
  query subscriptionOffers($organizationSlug: String!) {
    organization(organizationSlug: $organizationSlug) {
      ... on Organization {
        __typename
        id
        outboundSubscriptionOffers {
          __typename
          id
          email
          status
          name
          createdAt
          expiresAt
          payment {
            __typename
            monthlyPriceUSD
            trialDays
          }
          app {
            __typename
            id
            displayName
            pictureUrl
          }
        }
      }
  }
  }
`);

export function useSubscriptionOffers(organizationSlug: string = "") {
  const { data, ...res } = useQuery(SUBSCRIPTION_OFFERS, {
    variables: {
      organizationSlug
    },
    skip: !organizationSlug
  });

  const subscriptionOffers =
    data?.organization.__typename === "Organization"
      ? data.organization.outboundSubscriptionOffers
      : [];

  return { data: subscriptionOffers, ...res };
}
